import { Node } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'
import { NodeViewWrapper, NodeViewContent } from '@tiptap/react'
//@ts-ignore
import remixiconUrl from 'remixicon/fonts/remixicon.symbol.svg'

const SponsoredLinksComponent = () => {

  return (
    <NodeViewWrapper>
      <div className='max-w-lg m-auto'>
        <div className='font-semibold text-sm'>Sponsored links</div>
        <div className="flex flex-col space-y-2 bg-yellow-100 p-3 rounded-md border-1 border-yellow-300">
          {[
            'RELATED TERM 1', 'RELATED TERM 2', 'RELATED TERM 3', 
          ].map((item) => {
            return <div key={item} className='flex justify-between px-3 py-1 border-2 bg-white rounded-md border-yellow-400'>
              <div className='font-medium flex items-center space-x-3'>
                <svg className="w-5 h-5">
                  <use xlinkHref={`${remixiconUrl}#ri-search-line`} />
                </svg>
                <div>
                  {item}
                </div>
              </div>
              <button type='button' className="px-6 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none disabled:opacity-75" >SEARCH</button>
              </div>
          })}
        </div>
      </div>
      <NodeViewContent />
    </NodeViewWrapper>
  )
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    sponsoredLinks: {
      insertSponsoredLinks: () => ReturnType,
    }
  }
}

const SponsoredLinks = Node.create({
  name: 'sponsoredLinks',

  group: 'block',

  defining: true,

  addNodeView() {
    return ReactNodeViewRenderer(SponsoredLinksComponent)
  },

  renderHTML() {
    return ['sponsoredLinks', {}, 0 ]
  },

  addCommands() {
    return {
      insertSponsoredLinks: () => ({ commands }) => {
        return commands.insertContent({type: this.name})
      },
    }
  },
})

export default SponsoredLinks
